import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classnames from 'classnames';
import { ThemeProvider } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import { getIconButtonTheme, isDarkMode, ROOT_PREFIX } from './interactiveIconStyles';
import { useIntl } from 'react-intl';
import { useId } from '../utils/useId';
// eslint-disable-next-line react/display-name
export var InteractiveIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classnames;
  var _id = props.id,
    iconName = props.iconName,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$hoverColor = props.hoverColor,
    hoverColor = _props$hoverColor === void 0 ? 'purple' : _props$hoverColor,
    iconColor = props.iconColor,
    _props$iconSize = props.iconSize,
    iconSize = _props$iconSize === void 0 ? 'default' : _props$iconSize,
    onClick = props.onClick,
    selected = props.selected,
    className = props.className,
    label = props.label,
    tabIndex = props.tabIndex,
    role = props.role,
    ariaProps = props.ariaProps,
    keypressProps = props.keypressProps,
    dataTestId = props.dataTestId;
  var intl = useIntl();
  var defaultIconColor = isDarkMode(hoverColor) ? 'white' : 'text';
  var defaultLabel = iconName.replace('icon-', '').replace('-fill', '').replace('-', ' ');
  var id = useId(_id);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: getIconButtonTheme(hoverColor, iconColor || defaultIconColor)
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    ref: ref,
    id: id,
    "data-testid": dataTestId,
    tabIndex: tabIndex,
    "aria-label": label !== null && label !== void 0 ? label : intl.formatMessage({
      id: "embers.iconLabel.".concat(defaultLabel),
      defaultMessage: defaultLabel
    }),
    role: role !== null && role !== void 0 ? role : 'button',
    className: classnames(ROOT_PREFIX, className, (_classnames = {}, _defineProperty(_classnames, "".concat(ROOT_PREFIX, "-selected"), selected), _defineProperty(_classnames, "".concat(ROOT_PREFIX, "-small"), iconSize === 'small'), _classnames)),
    disableRipple: true,
    disabled: disabled,
    onClick: onClick
  }, keypressProps, ariaProps), /*#__PURE__*/React.createElement("i", {
    role: "none",
    className: iconName
  })));
});